var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCornerArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "corner-up-right-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33335 6.66687L3.33325 12.6668H4.66659L4.66666 8.0002L11.4479 8.00013L8.81472 10.6333L9.75752 11.5761L14.0002 7.33347L9.75752 3.09082L8.81472 4.03363L11.4479 6.6668L3.33335 6.66687Z",
    fill: "#797F86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerArrow);
export default __webpack_public_path__ + "static/media/corner-arrow.fbd18b361f7f41d917c7deba251505d7.svg";
export { ForwardRef as ReactComponent };